import { getLocale } from "../runtime";

const sv_campaigntitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kampanj`
};

const campaigntitle = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_campaigntitle(inputs)
	return "campaignTitle";
};

export { campaigntitle as "campaignTitle" };